import React from 'react'
import { connect } from 'react-redux'

import Intro from './Intro'
import App from './App'
import Result from './Result'

import logo from './logo.svg'


const ContentView = (props) => {
    if (props.progress === 'intro') {
        return <Intro />
    } else if (props.progress === 'in_game') {
        return <App />
    } else {
        return <Result />
    }
}

const mapStateToProps = (state) => ({
    progress: state.progress
})

const Content = connect(mapStateToProps)(ContentView)

const Nav = (props) => {
    return (
        <div>
            <div className='top-bar'>
                <div className='top-bar-left'>
                    <ul className='dropdown menu'>
                        <li className='menu-text'><a href='/'>Identical Faces</a></li>
                    </ul>
                </div>
                <div className='top-bar-right'>
                    <ul className='menu'>
                        <li><img src={logo} className='logo' alt='logo' /></li>
                    </ul>
                </div>
            </div>
            <div className='grid-container container'>
                <div className='grid-x grid-margin-x'>
                    <Content />
                </div>
            </div>
        </div>
    )
}

export default Nav



// WEBPACK FOOTER //
// ./src/Nav.js